import {
  React,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";

import AuthContext from "../../lib/auth-context";
import { DataFetcher } from "../../utils/dataFetcher";
import moment from "moment-timezone";
import ThemeContext from "../../lib/theme-context";
import CustomSingleTextField from "../textfields/singleRow";
import throwMessage from "../../utils/throwMessage";
import { getBacktestAccount } from "../../utils/backtestAccountUtils";
import { fetchEconomicCalendar } from "../../services/api/economicCalendarRequest";
import { getJSON } from "../../utils/safeLocalStorage";
import { invalidateUserCache } from "../../utils/dataCache";
import { accountService } from "../../services/api/accountService";
import { mongoDBRequest } from "../../services/api/dbRequest";
import { getCurrentServerTimeParts } from "../../utils/timezones";

import CustomSelect from "../select/index";
import InstrumentSelect from "../select/InstrumentSelect";
import CustomDateTimePicker from "../dateTimePickers/DateTimePicker";
import AccountSelector from "../AccountSelector";
import PositionVisualizer from "../PositionVisualizer";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ClearAllIcon from "@mui/icons-material/ClearAll";

import Chip from "@mui/material/Chip";
import UnarchivedTestsDropDown from "../select/unarchivedTestsDropDown";
import dayjs from "dayjs";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import markets from "../../lib/markets";
import { getEquityTypeFromAccount } from "../../utils/accountUtils";

// import ChecklistIcon from "@mui/icons-material/Checklist";

import SaveIcon from "@mui/icons-material/Save";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CalculateIcon from "@mui/icons-material/Calculate";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Tooltip from "@mui/material/Tooltip";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";

import useWindowDimensions from "../../utils/width";
import oandaConnect from "../../services/oanda";

const fx = require("simple-fxtrade");

const questions = [
  "Am I positioned well?",
  "What kind sequence has priced formed?",
  "Is this trade a HIGH or LOW risk trade?",
  "Can I move my stop loss to BE before the next major inflection point?",
  "Why would I be wrong?",
  "Are the spreads low enough to safely enter the position?",
];

const NewEntry = ({ open, onClose, calculateFields, onOpenForecast }) => {
  const theme = useContext(ThemeContext);
  const auth = useContext(AuthContext);
  const { width } = useWindowDimensions();

  const [q1, setQ1] = useState(false);
  const [q2, setQ2] = useState(false);
  const [q3, setQ3] = useState(false);
  const [q4, setQ4] = useState(false);
  const [q5, setQ5] = useState(false);
  const [q6, setQ6] = useState(false);

  // const [session, setSession] = useState("");
  // const [sessionTimezone, setSessionTimezone] = useState("");

  const handleChangeQuestions = (event, index) => {
    switch (index) {
      case 0:
        setQ1(event.target.checked);
        break;
      case 1:
        setQ2(event.target.checked);
        break;
      case 2:
        setQ3(event.target.checked);
        break;
      case 3:
        setQ4(event.target.checked);
        break;
      case 4:
        setQ5(event.target.checked);
        break;
      case 5:
        setQ6(event.target.checked);
        break;
      default:
        break;
    }
  };

  const QuestionsList = () => {
    return questions.map((q, i) => {
      return (
        <FormGroup
          key={q}
          defaultunchecked="true"
          sx={{
            color: theme[0] === "dark" ? "#FCFCFF" : "black",
            width: width <= 500 ? "100%" : "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "flex-start",
            paddingLeft: width <= 500 ? "0px" : "40px",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  i === 0
                    ? q1
                    : i === 1
                      ? q2
                      : i === 2
                        ? q3
                        : i === 3
                          ? q4
                          : i === 4
                            ? q5
                            : i === 5
                              ? q6
                              : null
                }
                onChange={(e) => handleChangeQuestions(e, i)}
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "black",
                  margin: "20px",
                }}
              />
            }
            label={q}
          />
        </FormGroup>
      );
    });
  };

  const [preTradeCheckList, setPreTradeCheckList] = useState(true);
  const [checkListView, setCheckListView] = useState(false);

  const [stopPrice, setStopPrice] = useState("");

  // inputs
  const [pair, setPair] = useState("");
  const [direction, setDirection] = useState("");
  const [entry, setEntry] = useState(dayjs(new Date()));
  const [exit, setExit] = useState(dayjs(new Date()));
  const [stopLossPips, setStopLossPips] = useState(""); // shared with calculator
  const [risk, setRisk] = useState(1); // shared with calculator
  const [openPrice, setOpenPrice] = useState("");
  const [closePrice, setClosePrice] = useState("");
  const [entryType, setEntryType] = useState("");
  const [tradingStyle, setTradingStyle] = useState("Intraday"); // Intraday or Swing
  const [grade, setGrade] = useState("");
  const [highlightedPair, setHighlightedPair] = useState("");
  const [firstEntryOrScaleIn, setFirstEntryOrScaleIn] = useState("");
  const [alphaPattern, setAlphaPattern] = useState("");
  const [betaPattern, setBetaPattern] = useState("");
  const [assignedTestId, setAssignedTestId] = useState("");
  const [missedTradeYes, setMissedTradeYes] = useState("");
  const [pairNews, setPairNews] = useState([]);
  const [missedTrade, setMissedTrade] = useState(false);
  const [selectedLiveAccount, setSelectedLiveAccount] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const openPriceChangedRef = useRef(false);

  // Initialize missedTrade from localStorage
  useEffect(() => {
    const storedMissedTrade = localStorage.getItem("missed-trade") === "Yes";
    setMissedTrade(storedMissedTrade);
    if (storedMissedTrade) {
      setMissedTradeYes("Yes");
    } else {
      setMissedTradeYes("");
    }
  }, []);

  const [equityType, setEquityType] = useState();
  const [selectedAccountId, setSelectedAccountId] = useState();
  const [accountsFromAPI, setAccountsFromAPI] = useState([]);
  const [entryTimeLabel, setEntryTimeLabel] = useState("Entry Time Server");

  const fetchAccountsFromAPI = async () => {
    try {
      const accounts = await accountService.getAccounts();
      setAccountsFromAPI(accounts);
    } catch (error) {
      console.error("Error fetching accounts from API:", error);
    }
  };

  const getBalance = useCallback(() => {
    // Handle backtesting mode - calculate cumulative balance from existing trades
    if (auth.backtestingMode) {
      const activeBacktestId = localStorage.getItem("backtest-active");
      if (activeBacktestId && auth.trades && auth.trades.length > 0) {
        // Get starting balance from backtest account
        const backtestAccount = getBacktestAccount();
        let currentBalance = backtestAccount.currentBalance;

        // Filter trades for this specific backtest
        const backtestTrades = auth.trades.filter(
          (trade) =>
            trade.testId === activeBacktestId &&
            trade.equityType === "Backtest",
        );

        // Sort trades by creation date to calculate cumulative balance
        backtestTrades.sort((a, b) => moment(a.created).diff(b.created));

        // Calculate cumulative balance
        backtestTrades.forEach((trade) => {
          if (trade.profitLossDollarBacktest) {
            currentBalance += parseFloat(trade.profitLossDollarBacktest || 0);
          }
          if (trade.feeBacktest) {
            currentBalance += parseFloat(trade.feeBacktest || 0);
          }
          if (trade.swapBacktest) {
            currentBalance += parseFloat(trade.swapBacktest || 0);
          }
        });

        return currentBalance.toString();
      } else {
        // No active backtest or no trades, return starting balance
        return getBacktestAccount().currentBalance.toString();
      }
    }

    const selectedAccountId = localStorage.getItem("selected-account-id");
    if (!selectedAccountId || selectedAccountId === "All") {
      // Calculate total balance for all accounts dynamically from API
      const accounts = accountsFromAPI || [];
      let totalBalance = 0;
      accounts.forEach((account) => {
        if (account.isActive) {
          let currentBalance = parseFloat(account.startingBalance) || 0;

          // Add trades
          if (auth.trades && auth.trades.length > 0) {
            const accountTrades = auth.trades.filter(
              (trade) =>
                trade &&
                trade.accountId === account.id &&
                trade.id &&
                trade.id.includes("live-"),
            );
            accountTrades.forEach((trade) => {
              if (trade.equityType === "Personal Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarPersonal || 0,
                );
                currentBalance += parseFloat(trade.feePC || 0);
                currentBalance += parseFloat(trade.swapPC || 0);
              } else if (trade.equityType === "Investor Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarInvestor || 0,
                );
                currentBalance += parseFloat(trade.feeIC || 0);
                currentBalance += parseFloat(trade.swapIC || 0);
              }
            });
          }

          // Add transactions
          if (account.transactions && account.transactions.length > 0) {
            account.transactions.forEach((txn) => {
              if (txn.type === "deposit") {
                currentBalance += parseFloat(txn.amount || 0);
              } else if (txn.type === "withdrawal" || txn.type === "payout") {
                currentBalance -= parseFloat(txn.amount || 0);
              }
            });
          }

          totalBalance += currentBalance;
        }
      });
      return totalBalance.toString();
    } else if (selectedAccountId === "All Personal") {
      // Calculate total personal balance dynamically from API
      const accounts = accountsFromAPI || [];
      let totalPersonalBalance = 0;
      accounts.forEach((account) => {
        if (account.isActive && account.type === "Personal") {
          let currentBalance = parseFloat(account.startingBalance) || 0;

          // Add trades
          if (auth.trades && auth.trades.length > 0) {
            const accountTrades = auth.trades.filter(
              (trade) =>
                trade &&
                trade.accountId === account.id &&
                trade.id &&
                trade.id.includes("live-"),
            );
            accountTrades.forEach((trade) => {
              if (trade.equityType === "Personal Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarPersonal || 0,
                );
                currentBalance += parseFloat(trade.feePC || 0);
                currentBalance += parseFloat(trade.swapPC || 0);
              }
            });
          }

          // Add transactions
          if (account.transactions && account.transactions.length > 0) {
            account.transactions.forEach((txn) => {
              if (txn.type === "deposit") {
                currentBalance += parseFloat(txn.amount || 0);
              } else if (txn.type === "withdrawal" || txn.type === "payout") {
                currentBalance -= parseFloat(txn.amount || 0);
              }
            });
          }

          totalPersonalBalance += currentBalance;
        }
      });
      return totalPersonalBalance.toString();
    } else if (selectedAccountId === "All Investor") {
      // Calculate total investor balance dynamically from API
      const accounts = accountsFromAPI || [];
      let totalInvestorBalance = 0;
      accounts.forEach((account) => {
        if (account.isActive && account.type === "Investor") {
          let currentBalance = parseFloat(account.startingBalance) || 0;

          // Add trades
          if (auth.trades && auth.trades.length > 0) {
            const accountTrades = auth.trades.filter(
              (trade) =>
                trade &&
                trade.accountId === account.id &&
                trade.id &&
                trade.id.includes("live-"),
            );
            accountTrades.forEach((trade) => {
              if (trade.equityType === "Investor Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarInvestor || 0,
                );
                currentBalance += parseFloat(trade.feeIC || 0);
                currentBalance += parseFloat(trade.swapIC || 0);
              }
            });
          }

          // Add transactions
          if (account.transactions && account.transactions.length > 0) {
            account.transactions.forEach((txn) => {
              if (txn.type === "deposit") {
                currentBalance += parseFloat(txn.amount || 0);
              } else if (txn.type === "withdrawal" || txn.type === "payout") {
                currentBalance -= parseFloat(txn.amount || 0);
              }
            });
          }

          totalInvestorBalance += currentBalance;
        }
      });
      return totalInvestorBalance.toString();
    } else {
      // Calculate current balance for specific account from API
      const accounts = accountsFromAPI || [];
      const account = accounts.find((acc) => acc.id === selectedAccountId);

      if (account) {
        const startingBalance = parseFloat(account.startingBalance) || 0;
        let currentBalance = startingBalance;

        // Add profit/loss from trades for this account
        if (auth.trades && auth.trades.length > 0) {
          const accountTrades = auth.trades.filter(
            (trade) =>
              trade.accountId === selectedAccountId &&
              trade.id &&
              trade.id.includes("live-"),
          );

          accountTrades.forEach((trade) => {
            if (trade.equityType === "Personal Capital") {
              currentBalance += parseFloat(trade.profitLossDollarPersonal || 0);
              currentBalance += parseFloat(trade.feePC || 0);
              currentBalance += parseFloat(trade.swapPC || 0);
            } else if (trade.equityType === "Investor Capital") {
              currentBalance += parseFloat(trade.profitLossDollarInvestor || 0);
              currentBalance += parseFloat(trade.feeIC || 0);
              currentBalance += parseFloat(trade.swapIC || 0);
            }
          });
        }

        // Add transactions (deposits, withdrawals, payouts)
        if (account.transactions && account.transactions.length > 0) {
          account.transactions.forEach((txn) => {
            if (txn.type === "deposit") {
              currentBalance += parseFloat(txn.amount || 0);
            } else if (txn.type === "withdrawal" || txn.type === "payout") {
              currentBalance -= parseFloat(txn.amount || 0);
            }
          });
        }

        return currentBalance.toString();
      }
      return "0";
    }
  }, [auth.trades, auth.backtestingMode, accountsFromAPI]);

  // Reload account balance when accounts are updated (e.g., after payout)
  useEffect(() => {
    const handleAccountsUpdated = () => {
      // Fetch fresh accounts from API
      fetchAccountsFromAPI();
    };

    window.addEventListener("accounts-updated", handleAccountsUpdated);
    return () =>
      window.removeEventListener("accounts-updated", handleAccountsUpdated);
  }, [auth.trades]);

  // Fetch accounts from API on mount
  useEffect(() => {
    fetchAccountsFromAPI();
  }, []);

  // Update balance when accounts are fetched from API
  useEffect(() => {
    if (selectedAccountId) {
      setAccountBalance(Number(getBalance()).toFixed(2));
    }
  }, [accountsFromAPI, selectedAccountId, getBalance]);

  // Calculator state (from cal.js)
  const [accountBalance, setAccountBalance] = useState();
  const [depositCurrency, setDepositCurrency] = useState("USD");

  // Load contract size from user data or default to 100000
  const getUserContractSize = () => {
    const user = getJSON("user", {});
    return user.contractSize || 100000;
  };

  const [contractSize, setContractSize] = useState(getUserContractSize());
  const [exchangeRate, setExchangeRate] = useState(0);

  const [lots, setLots] = useState(0);
  const [units, setUnits] = useState(0);
  const [moneyRisk, setMoneyRisk] = useState(0);
  const [exchangeLabel, setExchangeLabel] = useState("");

  const [savedSlots, setSavedSlots] = useState([]);
  const [recentTrades, setRecentTrades] = useState([]);
  const [selectedTradeToLoad, setSelectedTradeToLoad] = useState("");
  const [loadedTradeId, setLoadedTradeId] = useState("");
  const [loadedJournalId, setLoadedJournalId] = useState("");
  const [loadedJournalComplete, setLoadedJournalComplete] = useState(false);
  const [loadedForecastId, setLoadedForecastId] = useState("");

  // Screenshot fields from loaded trade
  const [loadedScreenshots, setLoadedScreenshots] = useState({
    dxyHourlyBefore: "",
    dxyHourlyAfter: "",
    dxyDailyBefore: "",
    dxyDailyAfter: "",
    min5_before: "",
    min15_before: "",
    hour1_before: "",
    hour1_after: "",
    hour4_before: "",
    hour4_after: "",
    daily_before: "",
    daily_after: "",
    weekly_before: "",
    weekly_after: "",
  });

  // Note: We may want to control the exchange rate field with a ref or extra state,
  // but we will use the existing `hide` flag, so no extra state is required.

  const [, setHidExchangeRate] = useState(true);
  const [customContractSize, setCustomContractSize] = useState(false);
  const [showContractDropdown, setShowContractDropdown] = useState(false);

  // Save contract size to user model
  const saveContractSize = async (newSize) => {
    try {
      const user = getJSON("user", {});
      if (user._id) {
        await mongoDBRequest("contract-size", "PUT", {
          user_id: user._id,
          contractSize: newSize,
        });
        // Update local storage
        user.contractSize = newSize;
        localStorage.setItem("user", JSON.stringify(user));

        // Invalidate cache so next page load gets updated user data
        await invalidateUserCache(user._id);
      }
    } catch (err) {
      console.error("Failed to save contract size:", err);
    }
  };

  const assignTrade = (test) => {
    setAssignedTestId(test.testId);
    // When a backtest is selected, automatically set missed trade to "No"
    if (test.testId && test.testId !== "") {
      setMissedTradeYes("");
      setMissedTrade(false);
      localStorage.setItem("missed-trade", "No");

      // Calculate and update balance for selected backtest
      if (auth.trades && auth.trades.length > 0) {
        // Get starting balance from backtest account
        const backtestAccount = getBacktestAccount();
        let currentBalance = backtestAccount.currentBalance;

        // Filter trades for this specific backtest
        const backtestTrades = auth.trades.filter(
          (trade) =>
            trade.testId === test.testId && trade.equityType === "Backtest",
        );

        // Sort trades by creation date to calculate cumulative balance
        backtestTrades.sort((a, b) => moment(a.created).diff(b.created));

        // Add profit/loss from all existing trades
        backtestTrades.forEach((trade) => {
          if (trade.profitLossDollarPersonal) {
            currentBalance += parseFloat(trade.profitLossDollarPersonal || 0);
            currentBalance += parseFloat(trade.feePC || 0);
            currentBalance += parseFloat(trade.swapPC || 0);
          }
        });

        // Update the account balance field
        setAccountBalance(currentBalance.toFixed(2));
      } else {
        // No trades, use starting balance
        setAccountBalance(getBacktestAccount().currentBalance.toFixed(2));
      }
    } else {
      // No backtest selected, reset to starting balance
      setAccountBalance(getBacktestAccount().currentBalance.toFixed(2));
    }
  };

  const save = async (preTradeCheckList) => {
    if (pair) {
      const saveScheme = {
        pair: pair,
        direction: direction,
        entryDate: dayjs(entry).format("DD/MM/YY"),
        entryTime: dayjs(entry).format("HH:mm"),
        exitDate: auth.backtestingMode ? dayjs(exit).format("DD/MM/YY") : "",
        exitTime: auth.backtestingMode ? dayjs(exit).format("HH:mm") : "",
        openPricePC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? openPrice
            : 0,
        closePricePC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? closePrice
            : 0,
        openPriceIC: equityType === "Investor Capital" ? openPrice : 0,
        closePriceIC: equityType === "Investor Capital" ? closePrice : 0,
        entryType: entryType,
        grade: grade,
        highlightedPair: highlightedPair,
        firstEntryOrScaleIn: firstEntryOrScaleIn,
        betaPattern: betaPattern,
        alphaPattern: alphaPattern,
        stopLossIC: equityType === "Investor Capital" ? stopLossPips : 0,
        stopLossPC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? stopLossPips
            : 0,
        stopLossPricePC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? stopPrice
            : 0,
        stopLossPriceIC: equityType === "Investor Capital" ? stopPrice : 0,
        lotsPC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? lots
            : "",
        lotsIC: equityType === "Investor Capital" ? lots : "",
        unitsPC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? units
            : "",
        unitsIC: equityType === "Investor Capital" ? units : "",
        moneyPC:
          equityType === "Personal Capital" || equityType === "Backtest"
            ? moneyRisk
            : "",
        moneyIC: equityType === "Investor Capital" ? moneyRisk : 0,
        risk: risk || 0,
        testId:
          localStorage.getItem("missed-trade") === "Yes"
            ? "Missed Trades"
            : assignedTestId,
        created: entry,
        preTradeCheckList: preTradeCheckList ? preTradeCheckList : "",
        equityType: auth.backtestingMode ? "Backtest" : equityType,
        accountId: selectedAccountId || "",
        timezone: getTimezone(),
        missedTrade: missedTradeYes === "Yes" ? true : false,
        currentBalance: parseFloat(getBalance()) || 0,
        tradingStyle: tradingStyle, // Intraday or Swing
      };

      if (savedSlots.length >= 5) {
        throwMessage(
          "warning",
          "Maximum 5 slots allowed. Delete a slot first.",
        );
        return;
      }

      try {
        const result = await DataFetcher("save-trade-slot", saveScheme);
        if (result && result.success) {
          await refreshSavedSlots();
          throwMessage("success", `Saved to slot ${savedSlots.length + 1}`);
        } else {
          throwMessage("error", result?.message || "Failed to save slot");
        }
      } catch (error) {
        console.error("Error saving slot:", error);
        throwMessage("error", "Failed to save slot: " + error.message);
      }
    }
  };

  const handleCreateForecast = () => {
    // Validate required fields for forecast
    if (!pair) {
      throwMessage("warning", "Please select a pair first");
      return;
    }
    if (!direction) {
      throwMessage("warning", "Please select a direction first");
      return;
    }

    // Prepare pre-filled data
    const prefilledData = {
      pair: pair,
      direction: direction,
      date: entry || new Date(),
    };

    // Close the entry modal and open forecast modal with pre-filled data
    if (onOpenForecast) {
      onOpenForecast(prefilledData);
      onClose();
    } else {
      throwMessage("error", "Forecast modal not available");
    }
  };

  const idTradeGenerator = (type) => {
    if (type === "backtest") {
      const id = "backtest-" + Math.random().toString(16).slice(2);
      return id;
    } else if (type === "live") {
      const id = "live-" + Math.random().toString(16).slice(2);
      return id;
    } else if (type === "journal") {
      const id = "journal-" + Math.random().toString(16).slice(2);
      return id;
    }
  };

  const handleMissedYes = (e) => {
    setMissedTradeYes(e.target.value);
    setMissedTrade(true);
    localStorage.setItem("missed-trade", e.target.value);
    // Clear backtest selection when missed trade is "Yes"
    setAssignedTestId("");
    // Also clear any stored backtest selection
    if (typeof assignTrade === "function") {
      assignTrade({ testId: "" });
    }
  };

  const handleMissedNo = (e) => {
    setMissedTradeYes("");
    setMissedTrade(false);
    localStorage.setItem("missed-trade", e.target.value);
  };

  const handleLiveAccountSelect = (accountId) => {
    setSelectedLiveAccount(accountId || "");

    if (!accountId) {
      setAccountBalance("0");
      return;
    }

    try {
      // Find the selected account and update balance
      const liveAccounts = getLiveAccountBalances();
      const selectedAccount = liveAccounts.find(
        (account) => account && account.id === accountId,
      );

      if (selectedAccount && selectedAccount.balance) {
        setAccountBalance(selectedAccount.balance);
      } else {
        setAccountBalance("0");
      }
    } catch (error) {
      console.error("Error selecting live account:", error);
      setAccountBalance("0");
    }
  };

  const handleCheckListView = (d) => {
    setCheckListView(d);
  };

  const refreshSavedSlots = async () => {
    try {
      const result = await DataFetcher("get-trade-slots", {});
      if (result && result.slots) {
        setSavedSlots(result.slots);
      } else {
        setSavedSlots([]);
      }
    } catch (error) {
      console.error("Error fetching saved slots:", error);
    }
  };

  const fetchRecentTrades = async () => {
    try {
      const result = await DataFetcher("recent-unique-trades", {});
      if (result && Array.isArray(result)) {
        setRecentTrades(result);
      } else {
        setRecentTrades([]);
      }
    } catch (error) {
      console.error("Error fetching recent trades:", error);
      setRecentTrades([]);
    }
  };

  const loadTradeFromHistory = async (tradeId) => {
    if (!tradeId) return;

    try {
      const result = await DataFetcher("single-trade", { _id: tradeId });
      const data = result;

      if (!data || !data.pair) {
        throwMessage("warning", "Trade data not found");
        return;
      }

      clearCalcFields();

      // Clear account selection so user can choose a different account
      setSelectedAccountId("");
      localStorage.setItem("selected-account-id", "");

      // Reset to default currency
      setDepositCurrency("USD");

      // Set balance based on current selection (will be 0 or total)
      setAccountBalance(Number(getBalance()).toFixed(2));

      setPair(data.pair || "");
      setDirection(data.direction || "");

      if (data.entryDate && data.entryTime) {
        const combined = dayjs(
          `${data.entryDate} ${data.entryTime}`,
          "DD/MM/YY HH:mm",
        );
        setEntry(combined.toDate());
      } else if (data.created) {
        setEntry(dayjs(data.created).toDate());
      }

      if (data.exitDate && data.exitTime) {
        const combinedExit = dayjs(
          `${data.exitDate} ${data.exitTime}`,
          "DD/MM/YY HH:mm",
        );
        setExit(combinedExit.toDate());
      } else if (data.created) {
        setExit(dayjs(data.created).toDate());
      }

      setOpenPrice(
        data.openPricePC || data.openPriceIC || data.openPrice || "",
      );
      setClosePrice(
        data.closePricePC || data.closePriceIC || data.closePrice || "",
      );
      setEntryType(data.entryType || "");
      setGrade(data.grade || "");
      setHighlightedPair(data.highlightedPair || "");
      setFirstEntryOrScaleIn(data.firstEntryOrScaleIn || "");
      setBetaPattern(data.betaPattern || "");
      setAlphaPattern(data.alphaPattern || "");
      setAssignedTestId(data.testId || "");
      setRisk(data.risk ?? 1);

      setEquityType(
        data.equityType || equityType || localStorage.getItem("equity-mode"),
      );

      setStopLossPips(data.stopLossPC || data.stopLossIC || 0);
      setStopPrice(data.stopLossPricePC || data.stopLossPriceIC || "");

      if (data.pair) {
        setTimeout(() => {
          runOandaFunc(data.pair);
        }, 100);
      }

      setLoadedTradeId(data._id);

      // Find the actual journal for this trade to get the correct journalID
      const actualJournal =
        auth.journals?.find((j) => j.trade_id === data._id) ||
        auth.journalsBacktesting?.find((j) => j.trade_id === data._id);
      const actualJournalId = actualJournal?.journalID || data.journalID || "";

      setLoadedJournalId(actualJournalId);
      setLoadedJournalComplete(data.journalComplete);
      setLoadedForecastId(data.foreCastId || "");

      // Store screenshot fields
      setLoadedScreenshots({
        dxyHourlyBefore: data.dxyHourlyBefore || "",
        dxyHourlyAfter: data.dxyHourlyAfter || "",
        dxyDailyBefore: data.dxyDailyBefore || "",
        dxyDailyAfter: data.dxyDailyAfter || "",
        min5_before: data.min5_before || "",
        min15_before: data.min15_before || "",
        hour1_before: data.hour1_before || "",
        hour1_after: data.hour1_after || "",
        hour4_before: data.hour4_before || "",
        hour4_after: data.hour4_after || "",
        daily_before: data.daily_before || "",
        daily_after: data.daily_after || "",
        weekly_before: data.weekly_before || "",
        weekly_after: data.weekly_after || "",
      });

      setSelectedTradeToLoad("");
      throwMessage(
        "success",
        `Loaded ${data.pair} - click Calculate to update position sizing`,
      );
    } catch (error) {
      console.error("Error loading trade:", error);
      throwMessage("error", "Failed to load trade");
    }
  };

  const loadSlot = (slotId) => {
    const data = savedSlots.find((slot) => slot._id === slotId);

    if (!data || !data.pair) {
      throwMessage("warning", "Selected slot is empty");
      return;
    }

    // Clear calculation fields first
    clearCalcFields();

    // Clear account selection first so a stale account isn't left over
    // when the loaded slot has no associated account
    setSelectedAccountId("");
    localStorage.removeItem("selected-account-id");

    // Restore selected account ID and currency first
    if (data.accountId) {
      setSelectedAccountId(data.accountId);
      localStorage.setItem("selected-account-id", data.accountId);

      // Update deposit currency based on loaded account
      const accountCurrency = getAccountCurrency(data.accountId);
      setDepositCurrency(accountCurrency);

      // Update account balance from current account, not saved balance
      setAccountBalance(Number(getBalance()).toFixed(2));
    } else {
      // Use saved balance if no account ID
      if (data.currentBalance) {
        setAccountBalance(Number(data.currentBalance).toFixed(2));
      }
    }

    // Restore trade data
    setPair(data.pair || "");
    setDirection(data.direction || "");

    // Use the slot's equityType to determine which fields to load
    const slotEquityType =
      data.equityType || equityType || localStorage.getItem("equity-mode");

    setEquityType(slotEquityType);

    if (data.entryDate && data.entryTime) {
      const combined = dayjs(
        `${data.entryDate} ${data.entryTime}`,
        "DD/MM/YY HH:mm",
      );
      setEntry(combined.toDate());
    } else if (data.created) {
      setEntry(dayjs(data.created).toDate());
    }

    if (data.exitDate && data.exitTime) {
      const combinedExit = dayjs(
        `${data.exitDate} ${data.exitTime}`,
        "DD/MM/YY HH:mm",
      );
      setExit(combinedExit.toDate());
    } else if (data.created) {
      setExit(dayjs(data.created).toDate());
    }

    // Load price fields based on the slot's equityType
    const loadedOpenPrice =
      slotEquityType === "Investor Capital"
        ? data.openPriceIC || data.openPrice || ""
        : data.openPricePC || data.openPrice || "";
    const loadedClosePrice =
      slotEquityType === "Investor Capital"
        ? data.closePriceIC || data.closePrice || ""
        : data.closePricePC || data.closePrice || "";
    const loadedStopLossPips =
      slotEquityType === "Investor Capital"
        ? data.stopLossIC || 0
        : data.stopLossPC || 0;
    const loadedStopPrice =
      slotEquityType === "Investor Capital"
        ? data.stopLossPriceIC || ""
        : data.stopLossPricePC || "";

    setOpenPrice(loadedOpenPrice);
    setClosePrice(loadedClosePrice);
    setEntryType(data.entryType || "");
    setTradingStyle(data.tradingStyle || "Intraday"); // Load trading style from slot
    setGrade(data.grade || "");
    setHighlightedPair(data.highlightedPair || "");
    setFirstEntryOrScaleIn(data.firstEntryOrScaleIn || "");
    setBetaPattern(data.betaPattern || "");
    setAlphaPattern(data.alphaPattern || "");
    setAssignedTestId(data.testId || "");
    setRisk(data.risk ?? 1);

    setStopLossPips(loadedStopLossPips);
    setStopPrice(loadedStopPrice);

    // Restore previously calculated values (lots / units / money risk)
    setLots(data.lotsPC || data.lotsIC || 0);
    setUnits(data.unitsPC || data.unitsIC || 0);
    setMoneyRisk(data.moneyPC || data.moneyIC || 0);

    // Only set exchange rates, no auto-calculation
    if (data.pair) {
      setTimeout(() => {
        runOandaFunc(data.pair);
      }, 100);
    }

    throwMessage("success", `Loaded ${data.pair}`);
  };

  const clearSlot = async (slotId) => {
    try {
      const result = await DataFetcher("delete-trade-slot", { slotId });
      if (result && result.success) {
        await refreshSavedSlots();
        throwMessage("success", "Slot deleted");
      } else {
        throwMessage("error", "Failed to delete slot");
      }
    } catch (error) {
      console.error("Error deleting slot:", error);
      throwMessage("error", "Failed to delete slot");
    }
  };

  // Function to get all live account balances for dropdown
  const getLiveAccountBalances = () => {
    try {
      const accounts = accountsFromAPI || [];
      const balances = [];

      // Add individual accounts
      accounts.forEach((account) => {
        if (account && account.isActive && account.id && account.name) {
          let currentBalance = parseFloat(account.startingBalance) || 0;

          // Calculate current balance from trades
          if (auth.trades && auth.trades.length > 0) {
            const accountTrades = auth.trades.filter(
              (trade) =>
                trade &&
                trade.accountId === account.id &&
                trade.id &&
                trade.id.includes("live-"),
            );

            accountTrades.forEach((trade) => {
              if (trade.equityType === "Personal Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarPersonal || 0,
                );
                currentBalance += parseFloat(trade.feePC || 0);
                currentBalance += parseFloat(trade.swapPC || 0);
              } else if (trade.equityType === "Investor Capital") {
                currentBalance += parseFloat(
                  trade.profitLossDollarInvestor || 0,
                );
                currentBalance += parseFloat(trade.feeIC || 0);
                currentBalance += parseFloat(trade.swapIC || 0);
              }
            });
          }

          // Add transactions (deposits, withdrawals, payouts)
          if (account.transactions && account.transactions.length > 0) {
            account.transactions.forEach((txn) => {
              if (txn.type === "deposit") {
                currentBalance += parseFloat(txn.amount || 0);
              } else if (txn.type === "withdrawal" || txn.type === "payout") {
                currentBalance -= parseFloat(txn.amount || 0);
              }
            });
          }

          balances.push({
            id: account.id,
            name: account.name,
            type: account.type || "Personal",
            balance: currentBalance.toFixed(2),
          });
        }
      });

      // Count personal and investor accounts
      const personalAccountCount = balances.filter(
        (acc) => acc.type === "Personal",
      ).length;
      const investorAccountCount = balances.filter(
        (acc) => acc.type === "Investor",
      ).length;

      // Add "All Personal" and "All Investor" options only if there are multiple accounts of that type
      let totalPersonalBalance = 0;
      let totalInvestorBalance = 0;

      if (auth.trades && auth.trades.length > 0) {
        auth.trades.forEach((trade) => {
          if (trade && trade.id && trade.id.includes("live-")) {
            if (
              trade.equityType === "Personal Capital" &&
              trade.profitLossDollarPersonal
            ) {
              totalPersonalBalance += parseFloat(
                trade.profitLossDollarPersonal || 0,
              );
              totalPersonalBalance += parseFloat(trade.feePC || 0);
              totalPersonalBalance += parseFloat(trade.swapPC || 0);
            } else if (
              trade.equityType === "Investor Capital" &&
              trade.profitLossDollarInvestor
            ) {
              totalInvestorBalance += parseFloat(
                trade.profitLossDollarInvestor || 0,
              );
              totalInvestorBalance += parseFloat(trade.feeIC || 0);
              totalInvestorBalance += parseFloat(trade.swapIC || 0);
            }
          }
        });
      }

      // Add starting balances to totals
      accounts.forEach((account) => {
        if (account && account.isActive) {
          const startingBalance = parseFloat(account.startingBalance) || 0;
          if (account.type === "Personal") {
            totalPersonalBalance += startingBalance;
          } else if (account.type === "Investor") {
            totalInvestorBalance += startingBalance;
          }
        }
      });

      // Only add "All Personal" if there are multiple personal accounts
      if (personalAccountCount > 1) {
        balances.push({
          id: "All Personal",
          name: "All Personal Accounts",
          type: "Personal",
          balance: totalPersonalBalance.toFixed(2),
        });
      }

      // Only add "All Investor" if there are multiple investor accounts
      if (investorAccountCount > 1) {
        balances.push({
          id: "All Investor",
          name: "All Investor Accounts",
          type: "Investor",
          balance: totalInvestorBalance.toFixed(2),
        });
      }

      return balances;
    } catch (error) {
      console.error("Error getting live account balances:", error);
      return [];
    }
  };

  // === CALCULATOR LOGIC BROUGHT FROM cal.js ===

  const externalAPICall = async (pairCode) => {
    return fetch(
      `https://v6.exchangerate-api.com/v6/${process.env.REACT_APP_FREE_API_KEY}/latest/${pairCode}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    ).then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        const error = { error: `error with status ${response.status}` };
        throw error;
      }
    });
  };

  const runExternalAPICall = async (baseCurrency) => {
    return externalAPICall(baseCurrency)
      .then((result) => {
        return result.conversion_rates;
      })
      .catch((error) => {
        return [];
      });
  };

  const getExchangeRateFromExternalAPI = async (fromCurrency, toCurrency) => {
    try {
      const rates = await runExternalAPICall(fromCurrency);
      if (rates && rates[toCurrency]) {
        const rate = rates[toCurrency];
        return rate;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };

  const clearCalcFields = () => {
    setLots(0);
    setUnits(0);
    setMoneyRisk(0);
  };

  const runOandaFunc = async (pairSymbol) => {
    const found = markets.find((p) => p.ticker === pairSymbol);
    if (!found) {
      throwMessage("warning", "Instrument not found");
      return;
    }

    try {
      if (found.multiplier === 1) {
        await runForexCals(pairSymbol, found);
      } else if (found?.baseCurrency) {
        await runIndicesCals(pairSymbol, found);
      } else if (found?.commoditie || found?.crypto) {
        await runCommoditiesCals(pairSymbol, found);
      } else {
      }
    } catch (error) {
      throwMessage("warning", "Could not fetch exchange rates");
    }
  };

  const checkPairNews = async (pairSymbol) => {
    setPairNews([]);
    if (!pairSymbol || pairSymbol.length !== 6) return;

    const baseCurrency = pairSymbol.substring(0, 3).toUpperCase();
    const quoteCurrency = pairSymbol.substring(3, 6).toUpperCase();

    try {
      const result = await fetchEconomicCalendar({ period: "week" });
      if (!result || !Array.isArray(result.events)) return;

      const now = moment();
      const cutoff = moment().add(24, "hours");

      const upcoming = result.events.filter((event) => {
        const eventDate = moment.utc(event.date).local();
        if (!eventDate.isValid()) return false;
        if (eventDate.isBefore(now) || eventDate.isAfter(cutoff)) return false;

        const eventCurrency = (event.currency || "").toUpperCase().trim();
        if (!eventCurrency) return false;

        const currencies = eventCurrency.split(/[,/\s]+/).filter(Boolean);
        const affectsPair =
          currencies.includes(baseCurrency) ||
          currencies.includes(quoteCurrency);
        if (!affectsPair) return false;

        return event.impact?.toLowerCase() === "high";
      });

      const sorted = upcoming.sort((a, b) =>
        moment.utc(a.date).local().diff(moment.utc(b.date).local()),
      );

      setPairNews(sorted);
    } catch (error) {
      console.error("Error checking pair news:", error);
    }
  };

  const runIndicesCals = async (pairSymbol, found) => {
    const reverseListUSD = [
      "AUS200",
      "ESP35",
      "EUSTX50",
      "FRA40",
      "GER30",
      "UK100",
    ];
    const reverseListAUD = ["ESP35", "EUSTX50", "FRA40", "GER30", "UK100"];
    const reverseListGBP = ["ESP35", "EUSTX50", "FRA40", "GER30"];

    let buildPair;

    if (found.baseCurrency === depositCurrency) {
      setHidExchangeRate(true);
    } else {
      setHidExchangeRate(false);
    }

    setExchangeLabel(depositCurrency + "/" + found.baseCurrency);

    if (depositCurrency === "USD") {
      if (found.baseCurrency === "USD") {
        setExchangeRate(1);
      } else {
        if (reverseListUSD.find((p) => p === pairSymbol)) {
          buildPair = found.baseCurrency + "_" + depositCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            let reversed = 1 / Number(candles[candles.length - 1].mid.c);
            setExchangeRate(reversed.toFixed(5));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              found.baseCurrency,
              depositCurrency,
            );
            if (fallbackRate !== null) {
              const reversedRate = 1 / fallbackRate;
              setExchangeRate(reversedRate.toFixed(5));
            }
          }
        } else {
          buildPair = depositCurrency + "_" + found.baseCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            setExchangeRate(Number(candles[candles.length - 1].mid.c));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              depositCurrency,
              found.baseCurrency,
            );
            if (fallbackRate !== null) {
              setExchangeRate(fallbackRate);
            }
          }
        }
      }
    }
    if (depositCurrency === "AUD") {
      if (found.baseCurrency === "AUD") {
        setExchangeRate(1);
      } else {
        if (reverseListAUD.find((p) => p === pairSymbol)) {
          buildPair = found.baseCurrency + "_" + depositCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            let reversed = 1 / Number(candles[candles.length - 1].mid.c);
            setExchangeRate(reversed.toFixed(5));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              found.baseCurrency,
              depositCurrency,
            );
            if (fallbackRate !== null) {
              const reversedRate = 1 / fallbackRate;
              setExchangeRate(reversedRate.toFixed(5));
            }
          }
        } else {
          buildPair = depositCurrency + "_" + found.baseCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            setExchangeRate(Number(candles[candles.length - 1].mid.c));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              depositCurrency,
              found.baseCurrency,
            );
            if (fallbackRate !== null) {
              setExchangeRate(fallbackRate);
            }
          }
        }
      }
    }
    if (depositCurrency === "GBP") {
      if (found.baseCurrency === "GBP") {
        setExchangeRate(1);
      } else {
        if (reverseListGBP.find((p) => p === pairSymbol)) {
          buildPair = found.baseCurrency + "_" + depositCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            let reversed = 1 / Number(candles[candles.length - 1].mid.c);
            setExchangeRate(reversed.toFixed(5));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              found.baseCurrency,
              depositCurrency,
            );
            if (fallbackRate !== null) {
              const reversedRate = 1 / fallbackRate;
              setExchangeRate(reversedRate.toFixed(5));
            }
          }
        } else {
          buildPair = depositCurrency + "_" + found.baseCurrency;
          try {
            const { candles } = await fx.candles({ id: buildPair });
            setExchangeRate(Number(candles[candles.length - 1].mid.c));
          } catch (error) {
            throwMessage(
              "warning",
              "OANDA connection failed, using backup API",
            );
            const fallbackRate = await getExchangeRateFromExternalAPI(
              depositCurrency,
              found.baseCurrency,
            );
            if (fallbackRate !== null) {
              setExchangeRate(fallbackRate);
            }
          }
        }
      }
    }
  };

  const runCommoditiesCals = async () => {
    if (depositCurrency === "USD") {
      setHidExchangeRate(true);
    } else {
      setHidExchangeRate(false);
    }
    setExchangeLabel(`${depositCurrency}/USD`);

    if (depositCurrency === "USD") {
      setExchangeRate(1);
    } else {
      const pairId = `${depositCurrency}_USD`;
      try {
        const { candles } = await fx.candles({
          id: pairId,
        });
        setExchangeRate(Number(candles[candles.length - 1].mid.c));
      } catch (error) {
        throwMessage("warning", "OANDA connection failed, using backup API");
        const fallbackRate = await getExchangeRateFromExternalAPI(
          depositCurrency,
          "USD",
        );
        if (fallbackRate !== null) {
          setExchangeRate(fallbackRate);
        }
      }
    }
  };

  const runForexCals = async (pairSymbol, found) => {
    let buildPair;

    //us
    const reverseUSD = [
      "AUDNZD",
      "GBPAUD",
      "GBPNZD",
      "EURAUD",
      "EURGBP",
      "EURNZD",
    ];

    // aud
    const reverseAUD = ["GBPAUD", "EURAUD", "EURGBP"];

    // gbp
    const reverseGBP = ["EURGBP"];

    const runExchangeApi = async (reversed, buildPairId) => {
      try {
        const { candles } = await fx.candles({ id: buildPairId });
        if (!candles || candles.length === 0) {
          throw new Error("No candle data received");
        }
        if (reversed) {
          let reversed = 1 / Number(candles[candles.length - 1].mid.c);
          setExchangeRate(reversed.toFixed(5));
        } else {
          setExchangeRate(Number(candles[candles.length - 1].mid.c));
        }
      } catch (error) {
        if (
          error.message === "Network Error" ||
          error.message.includes("Network Error")
        ) {
          throwMessage("warning", "OANDA connection failed, using backup API");
          // Parse the buildPairId to get from/to currencies
          const [from, to] = buildPairId.split("_");
          const fallbackRate = await getExchangeRateFromExternalAPI(from, to);
          if (fallbackRate !== null) {
            if (reversed) {
              const reversedRate = 1 / fallbackRate;
              setExchangeRate(reversedRate.toFixed(5));
            } else {
              setExchangeRate(fallbackRate);
            }
            return; // Success with fallback
          }
          throw new Error(
            "OANDA API network error and external API fallback failed",
          );
        }
        throw error;
      }
    };

    setExchangeLabel(depositCurrency + "/" + found.oanda.split("_")[1]);

    if (found.oanda.split("_")[1] === "USD") {
      setExchangeRate(1);
    } else {
      if (depositCurrency === "USD") {
        if (reverseUSD.find((p) => p === pairSymbol)) {
          buildPair = found.oanda.split("_")[1] + "_" + depositCurrency;
          await runExchangeApi(true, buildPair);
        } else {
          buildPair = depositCurrency + "_" + found.oanda.split("_")[1];
          await runExchangeApi(false, buildPair);
        }
      } else if (depositCurrency === "AUD") {
        if (reverseAUD.find((p) => p === pairSymbol)) {
          buildPair = found.oanda.split("_")[0] + "_" + depositCurrency;
          await runExchangeApi(true, buildPair);
        } else {
          buildPair = depositCurrency + "_" + found.oanda.split("_")[1];
          await runExchangeApi(false, buildPair);
        }
      } else if (depositCurrency === "GBP") {
        if (reverseGBP.find((p) => p === pairSymbol)) {
          buildPair = found.oanda.split("_")[0] + "_" + depositCurrency;
          await runExchangeApi(true, buildPair);
        } else {
          buildPair = depositCurrency + "_" + found.oanda.split("_")[1];
          await runExchangeApi(false, buildPair);
        }
      } else {
      }
    }
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const pipValueCal = () => {
    const found = markets.find((p) => p.ticker === pair);
    if (!found || !exchangeRate) return 0;

    // For forex (multiplier === 1): standard formula
    if (found.multiplier === 1) {
      let result = (found.pipDistance / exchangeRate) * contractSize;
      return result;
    }

    // For non-forex (multiplier > 1):
    // - Commodities (gold, silver): multiplier / 100 (because we divide ticks by 100)
    //   Gold: multiplier 10 / 100 = $0.10 per tick
    //   Silver: multiplier 100 / 100 = $1 per tick
    // - Indices: multiplier / 10 (pipDistance is 0.1, so divide by 10)
    //   SPX500: multiplier 10 / 10 = $1 per tick
    // - Crypto: multiplier / 10
    //   BTC: multiplier 10 / 10 = $1 per tick

    if (found.commoditie) {
      return found.multiplier / 100;
    }

    // For indices & crypto: pip value = multiplier / 10
    return found.multiplier / 10;
  };

  const moneySizeCalculator = () => {
    let result = accountBalance * (risk / 100);
    return result;
  };

  const lotSizeCalculator = (moneyRiskValue) => {
    let pipValue = pipValueCal();
    if (!pipValue || !stopLossPips) return 0;

    // stopLossPips already represents the actual ticks for non-forex
    // No conversion needed
    let result = moneyRiskValue / (stopLossPips * pipValue);
    return result;
  };

  const runCals = () => {
    if (!stopLossPips || stopLossPips === 0) {
      throwMessage("warning", "Enter Stop Loss");
    } else {
      const _moneyRisk = moneySizeCalculator();
      const _lots = lotSizeCalculator(_moneyRisk);

      setMoneyRisk(_moneyRisk.toFixed(2));
      setLots(_lots.toFixed(3));

      let unitsVal = _lots * contractSize;
      setUnits(numberWithCommas(unitsVal.toFixed(3)));
    }
  };

  const getTimezone = () => {
    const storedTimezone = localStorage.getItem("economic-calendar-timezone");
    if (storedTimezone && storedTimezone !== "local") {
      return storedTimezone;
    }
    return moment.tz.guess();
  };

  // Get the appropriate label for stop loss based on instrument type
  const getStopLossLabel = () => {
    if (!pair) return "Stop Loss";
    const instrument = markets.find((m) => m.ticker === pair);
    if (!instrument) return "Stop Loss";

    // For forex (multiplier === 1), use "Pips"
    // For commodities, indices, crypto (multiplier > 1), use "Ticks"
    const unit = instrument.multiplier === 1 ? "Pips" : "Ticks";
    return `Stop Loss (${unit})`;
  };

  /* const getLocalSessionInfo = (sessionTime, marketTimezone) => {
    if (!sessionTime || sessionTime === 0) return null;
    
    const [startTime, endTime] = sessionTime.split("-");
    const userTz = moment.tz.guess();
    
    // Parse time string (format: "HH:mm" or "HHmm")
    const parseTime = (timeStr) => {
      const cleanTime = timeStr.replace(":", "");
      const hour = parseInt(cleanTime.substring(0, 2));
      const min = parseInt(cleanTime.substring(2, 4)) || 0;
      return { hour, min };
    };
    
    const { hour: startHour, min: startMin } = parseTime(startTime);
    const { hour: endHour, min: endMin } = parseTime(endTime);
    
    // If marketTimezone is provided, use it (DST-aware)
    // Otherwise, treat as UTC (legacy behavior)
    const sourceTimezone = marketTimezone || "UTC";
    
    // Create moment objects in the market's timezone
    const startMoment = moment.tz(sourceTimezone).startOf('day').hours(startHour).minutes(startMin).seconds(0);
    let endMoment = moment.tz(sourceTimezone).startOf('day').hours(endHour).minutes(endMin).seconds(0);
    
    // If session crosses midnight in market timezone
    const startNum = parseInt(startTime.replace(":", ""));
    const endNum = parseInt(endTime.replace(":", ""));
    if (startNum > endNum) {
      endMoment = endMoment.add(1, 'day');
    }
    
    // Convert to user's local time
    const startLocal = startMoment.clone().tz(userTz);
    const endLocal = endMoment.clone().tz(userTz);
    
    // Check if currently in session (compare in market timezone)
    const nowInMarketTz = moment.tz(sourceTimezone);
    const currentMarketTime = parseInt(nowInMarketTz.format("HHmm"));
    
    let inSession = false;
    if (startNum < endNum) {
      // Normal case: e.g., 0800-1700
      inSession = currentMarketTime >= startNum && currentMarketTime <= endNum;
    } else {
      // Crosses midnight: e.g., 2200-0700
      inSession = currentMarketTime >= startNum || currentMarketTime <= endNum;
    }
    
    const offset = moment.tz(userTz).format("Z");
    const offsetHours = offset.substring(0, 3);
    
    return {
      startLocal: startLocal.format("HH:mm"),
      endLocal: endLocal.format("HH:mm"),
      timezone: `UTC${offsetHours}`,
      inSession,
    };
  };
  */

  // Auto-calculation functions
  const calculateStopPriceFromPips = (
    pips,
    entryPrice,
    tradeDirection,
    instrument,
  ) => {
    if (!pips || !entryPrice || !tradeDirection || !instrument) {
      return null;
    }

    const numPips = Number(pips);
    const numEntry = Number(entryPrice);

    if (isNaN(numPips) || isNaN(numEntry) || numPips <= 0) {
      return null;
    }

    const pipDistance = instrument.pipDistance;

    // For forex (multiplier === 1): pips × pipDistance = price movement
    // For commodities (gold, silver): ticks × (pipDistance / 100) = price movement
    //   Example: Gold - 9018 ticks × 0.001 = $9.018
    // For indices & crypto: ticks × pipDistance = price movement
    //   Example: SPX500 - 200 ticks × 0.1 = $20.0
    let pipsValue;
    if (instrument.multiplier === 1) {
      // Forex
      pipsValue = numPips * pipDistance;
    } else if (instrument.commoditie) {
      // Commodities (gold, silver)
      pipsValue = numPips * (pipDistance / 100);
    } else {
      // Indices, crypto
      pipsValue = numPips * pipDistance;
    }

    const direction = tradeDirection.toLowerCase();

    // For LONG: stop is BELOW entry (entry - pips)
    // For SHORT: stop is ABOVE entry (entry + pips)
    if (direction === "long") {
      const result = (numEntry - pipsValue).toFixed(
        instrument.multiplier === 1 ? 5 : 2,
      );
      return result;
    } else if (direction === "short") {
      const result = (numEntry + pipsValue).toFixed(
        instrument.multiplier === 1 ? 5 : 2,
      );
      return result;
    }

    return null;
  };

  const calculatePipsFromStopPrice = (
    stopPriceValue,
    entryPrice,
    tradeDirection,
    instrument,
  ) => {
    if (!stopPriceValue || !entryPrice || !tradeDirection || !instrument)
      return null;

    const numStop = Number(stopPriceValue);
    const numEntry = Number(entryPrice);

    if (isNaN(numStop) || isNaN(numEntry)) return null;

    const pipDistance = instrument.pipDistance;
    const direction = tradeDirection.toLowerCase();

    // Validate stop is on correct side
    if (direction === "long" && numStop >= numEntry) {
      return null; // Stop should be below entry for long
    }
    if (direction === "short" && numStop <= numEntry) {
      return null; // Stop should be above entry for short
    }

    const priceDifference = Math.abs(numEntry - numStop);

    // For forex (multiplier === 1): priceDiff / pipDistance = pips
    // For commodities: priceDiff / (pipDistance / 100) = ticks
    //   Example: Gold - price diff $9.018, ticks = 9.018 / 0.001 = 9018
    // For indices & crypto: priceDiff / pipDistance = ticks
    //   Example: SPX500 - price diff $20.0, ticks = 20.0 / 0.1 = 200
    let pipsValue;
    if (instrument.multiplier === 1) {
      // Forex
      pipsValue = priceDifference / pipDistance;
    } else if (instrument.commoditie) {
      // Commodities (gold, silver)
      pipsValue = priceDifference / (pipDistance / 100);
    } else {
      // Indices, crypto
      pipsValue = priceDifference / pipDistance;
    }

    return pipsValue.toFixed(instrument.multiplier === 1 ? 1 : 0);
  };

  const handleStopLossChange = (value) => {
    clearCalcFields();
    setStopLossPips(value);

    // Clear stop price if value is empty
    if (!value || value === "" || value === "0") {
      setStopPrice("");
      return;
    }

    // Auto-calculate stop price if we have the required fields
    if (value && openPrice && direction && pair) {
      const instrument = markets.find((m) => m.ticker === pair);
      if (instrument) {
        const calculatedStopPrice = calculateStopPriceFromPips(
          value,
          openPrice,
          direction,
          instrument,
        );
        if (calculatedStopPrice) {
          setStopPrice(calculatedStopPrice);
        } else {
          console.warn("[Stop Loss] Failed to calculate stop price:", {
            value,
            openPrice,
            direction,
            pair,
            instrument: instrument?.ticker,
          });
        }
      } else {
        console.warn("[Stop Loss] Instrument not found for pair:", pair);
      }
    } else {
      console.warn("[Stop Loss] Missing required fields:", {
        value: !!value,
        openPrice: !!openPrice,
        direction: !!direction,
        pair: !!pair,
      });
    }
  };

  const handleStopPriceChange = (value) => {
    setStopPrice(value);

    // Clear stop loss pips if value is empty
    if (!value || value === "") {
      clearCalcFields();
      setStopLossPips(0);
      return;
    }

    // Auto-calculate stop loss pips if we have the required fields
    if (value && openPrice && direction && pair) {
      const instrument = markets.find((m) => m.ticker === pair);
      if (instrument) {
        const calculatedPips = calculatePipsFromStopPrice(
          value,
          openPrice,
          direction,
          instrument,
        );
        if (calculatedPips) {
          clearCalcFields();
          setStopLossPips(calculatedPips);
        } else {
          console.warn("[Stop Price] Failed to calculate pips:", {
            value,
            openPrice,
            direction,
            pair,
            instrument: instrument?.ticker,
          });
        }
      } else {
        console.warn("[Stop Price] Instrument not found for pair:", pair);
      }
    } else {
      console.warn("[Stop Price] Missing required fields:", {
        value: !!value,
        openPrice: !!openPrice,
        direction: !!direction,
        pair: !!pair,
      });
    }
  };

  // Auto-calculate stop price whenever required fields change (with debounce)
  useEffect(() => {
    // Don't auto-calculate if open price just changed
    if (openPriceChangedRef.current) {
      openPriceChangedRef.current = false;
      return;
    }

    const timer = setTimeout(() => {
      if (
        stopLossPips &&
        stopLossPips > 0 &&
        openPrice &&
        direction &&
        pair &&
        !stopPrice
      ) {
        const instrument = markets.find((m) => m.ticker === pair);
        if (instrument) {
          const calculatedStopPrice = calculateStopPriceFromPips(
            stopLossPips,
            openPrice,
            direction,
            instrument,
          );
          if (calculatedStopPrice) {
            setStopPrice(calculatedStopPrice);
          }
        }
      }
    }, 500); // Wait 500ms after user stops typing

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stopLossPips, openPrice, direction, pair]);

  // Auto-calculate stop loss pips whenever stop price changes (with debounce)
  useEffect(() => {
    // Don't auto-calculate if open price just changed
    if (openPriceChangedRef.current) {
      return;
    }

    const timer = setTimeout(() => {
      if (
        stopPrice &&
        openPrice &&
        direction &&
        pair &&
        (!stopLossPips || stopLossPips === 0)
      ) {
        const instrument = markets.find((m) => m.ticker === pair);
        if (instrument) {
          const calculatedPips = calculatePipsFromStopPrice(
            stopPrice,
            openPrice,
            direction,
            instrument,
          );
          if (calculatedPips) {
            setStopLossPips(calculatedPips);
          }
        }
      }
    }, 500); // Wait 500ms after user stops typing

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stopPrice, openPrice, direction, pair]);

  const submit = (handleClose) => {
    if (pair) {
      // Validate trading account selection for live mode
      if (
        !auth.backtestingMode &&
        (!selectedAccountId || selectedAccountId === "")
      ) {
        throwMessage("warning", "Select Trading Account");
        return;
      }

      // Validate calculated values are not 0
      if (lots === 0 || units === 0 || moneyRisk === 0) {
        throwMessage("warning", "Calculate position sizing.");
        return;
      }
      const sendRequest = async () => {
        // Derive equity type from selected account to ensure consistency
        // Use fresh API accounts data to avoid stale localStorage issues
        let finalEquityType = auth.backtestingMode
          ? "Backtest"
          : getEquityTypeFromAccount(selectedAccountId, accountsFromAPI);

        // Validate that we got a valid equity type for live mode
        if (!auth.backtestingMode && !finalEquityType) {
          throwMessage(
            "error",
            "Selected account not found. Please select a valid trading account.",
          );
          return;
        }

        // Use backtesting account when in backtest mode
        const finalAccountId = auth.backtestingMode
          ? getBacktestAccount().id
          : selectedAccountId || "";

        // Helper to convert string to number, handling commas
        const toNumber = (value) => {
          if (value === "" || value === null || value === undefined) return 0;
          if (typeof value === "number") return value;
          // Remove commas and convert to number
          const cleaned = String(value).replace(/,/g, "");
          const parsed = parseFloat(cleaned);
          return isNaN(parsed) ? 0 : parsed;
        };

        const schema = {
          id: auth.backtestingMode
            ? idTradeGenerator("backtest")
            : idTradeGenerator("live"),
          pair: pair,
          direction: direction,
          entryDate: dayjs(entry).format("DD/MM/YY"),
          entryTime: dayjs(entry).format("HH:mm"),
          exitDate: dayjs(exit).format("DD/MM/YY"),
          exitTime: dayjs(exit).format("HH:mm"),
          openPricePC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? openPrice
              : 0,
          ),
          closePricePC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? closePrice
              : 0,
          ),
          openPriceIC: toNumber(
            finalEquityType === "Investor Capital" ? openPrice : 0,
          ),
          closePriceIC: toNumber(
            finalEquityType === "Investor Capital" ? closePrice : 0,
          ),
          entryType: entryType,
          grade: grade,
          highlightedPair: highlightedPair,
          firstEntryOrScaleIn: firstEntryOrScaleIn,
          betaPattern: betaPattern,
          alphaPattern: alphaPattern,
          equityType: finalEquityType,
          accountId: finalAccountId,
          accountBalanceSnapshot: auth.backtestingMode
            ? getBacktestAccount().currentBalance
            : null,
          stopLossIC: toNumber(
            finalEquityType === "Investor Capital" ? stopLossPips : 0,
          ),
          stopLossPC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? stopLossPips
              : 0,
          ),
          stopLossPricePC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? stopPrice
              : 0,
          ),
          stopLossPriceIC: toNumber(
            finalEquityType === "Investor Capital" ? stopPrice : 0,
          ),
          lotsPC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? lots
              : 0,
          ),
          lotsIC: toNumber(finalEquityType === "Investor Capital" ? lots : 0),
          unitsPC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? units
              : 0,
          ),
          unitsIC: toNumber(finalEquityType === "Investor Capital" ? units : 0),
          moneyPC: toNumber(
            finalEquityType === "Personal Capital" ||
              finalEquityType === "Backtest"
              ? moneyRisk
              : 0,
          ),
          moneyIC: toNumber(
            finalEquityType === "Investor Capital" ? moneyRisk : 0,
          ),
          risk: toNumber(risk || 0),
          testId:
            localStorage.getItem("missed-trade") === "Yes"
              ? "Missed Trades"
              : assignedTestId,
          created: entry,
          timezone: getTimezone(),
          missedTrade: missedTradeYes === "Yes" ? true : false,
          currentBalance: toNumber(getBalance()),
          duplicatedFrom: loadedTradeId || "",
          journalID: loadedJournalId || "",
          journalComplete: loadedJournalComplete || false,
          foreCastId: loadedForecastId || "",
          tradingStyle: tradingStyle, // Day Trading or Swing Trading
          // Copy screenshot fields from loaded trade
          dxyHourlyBefore: loadedScreenshots.dxyHourlyBefore,
          dxyHourlyAfter: loadedScreenshots.dxyHourlyAfter,
          dxyDailyBefore: loadedScreenshots.dxyDailyBefore,
          dxyDailyAfter: loadedScreenshots.dxyDailyAfter,
          min5_before: loadedScreenshots.min5_before,
          min15_before: loadedScreenshots.min15_before,
          hour1_before: loadedScreenshots.hour1_before,
          hour1_after: loadedScreenshots.hour1_after,
          hour4_before: loadedScreenshots.hour4_before,
          hour4_after: loadedScreenshots.hour4_after,
          daily_before: loadedScreenshots.daily_before,
          daily_after: loadedScreenshots.daily_after,
          weekly_before: loadedScreenshots.weekly_before,
          weekly_after: loadedScreenshots.weekly_after,
        };

        const result = await DataFetcher("new-trade-entry", schema);
        if (result) {
          const virtual_array = auth.trades;

          virtual_array.push(result.trade);

          virtual_array.sort((a, b) => {
            return moment(a.created).diff(b.created);
          });

          auth.setTrades(virtual_array);

          calculateFields(virtual_array, auth.backtestingMode);

          if (auth.backtestingMode) {
            auth.setJournalsBacktesting([
              ...auth.journalsBacktesting,
              result.journal,
            ]);
          } else {
            auth.setJournals([...auth.journals, result.journal]);
          }
          throwMessage("success", `${schema?.pair} Added`);
          handleClose();
          clearForm();
        } else {
          throwMessage("error", "Something went wrong");
          setFormSubmitted(false);
        }
      };
      if (!auth.backtestingMode) {
        if (!formSubmitted);
        setFormSubmitted(true);
        sendRequest();
      } else if (auth.backtestingMode && assignedTestId) {
        if (!formSubmitted);
        setFormSubmitted(true);
        sendRequest();
      } else if (localStorage.getItem("missed-trade") === "Yes") {
        if (!formSubmitted);
        setFormSubmitted(true);
        sendRequest();
      } else {
        throwMessage("warning", "Assign Test");
      }
    } else {
      throwMessage("warning", "Select Instrument");
    }
  };

  const clearForm = () => {
    // setSession("");
    // setSessionTimezone("");
    setFormSubmitted(false);
    setBetaPattern("");
    setAlphaPattern("");
    setFirstEntryOrScaleIn("");
    setHighlightedPair("");
    setGrade("");
    setEntryType("");
    setClosePrice("");
    setOpenPrice("");
    setStopLossPips(0);
    setEntry(dayjs(new Date()));
    setExit(dayjs(new Date()));
    setDirection("");
    setPair("");
    setPairNews([]);
    setStopPrice("");
    setMissedTradeYes("");
    setLoadedTradeId("");
    setLoadedJournalId("");
    setLoadedJournalComplete(false);
    setLoadedForecastId("");
    setLoadedScreenshots({
      dxyHourlyBefore: "",
      dxyHourlyAfter: "",
      dxyDailyBefore: "",
      dxyDailyAfter: "",
      min5_before: "",
      min15_before: "",
      hour1_before: "",
      hour1_after: "",
      hour4_before: "",
      hour4_after: "",
      daily_before: "",
      daily_after: "",
      weekly_before: "",
      weekly_after: "",
    });
    localStorage.setItem("pre-trade-checklist", false);
    clearCalcFields();
    setRisk(1);
    setAccountBalance(Number(getBalance()).toFixed(2));
  };

  const handleChecklist = () => {
    if (q1 && q2 && q3 && q4 && q5 && q6) {
      handleCheckListView(false);
      setPreTradeCheckList(true);
      localStorage.setItem("pre-trade-checklist", true);
    } else {
      throwMessage("error", "Complete Checklist");
    }
  };

  const getAccountCurrency = (accountId) => {
    if (!accountId) return "USD";

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const accounts = user.capitalAccounts || [];
    const account = accounts.find((acc) => acc.id === accountId);

    return account?.currency || "USD";
  };

  const getServerTimeLabel = useCallback((accountId) => {
    if (!accountId) return "Entry Time Server";

    // First try to get account from API data (fresh)
    let account = accountsFromAPI.find((acc) => acc.id === accountId);

    // Fallback to localStorage if not found in API data
    if (!account) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const accounts = user.capitalAccounts || [];
      account = accounts.find((acc) => acc.id === accountId);
    }

    if (!account) return "Entry Time Server";

    const serverTimeParts = getCurrentServerTimeParts(account);
    if (!serverTimeParts) return "Entry Time Server";

    return `Entry Time Server: ( ${serverTimeParts.label}  ${serverTimeParts.time} )`;
  }, [accountsFromAPI]);

  const handleAccountChange = (event) => {
    const newAccountId = event.target.value;
    setSelectedAccountId(newAccountId);
    localStorage.setItem("selected-account-id", newAccountId);

    // Update equity type based on account
    // Use fresh API accounts data to avoid stale localStorage issues
    const newEquityType = getEquityTypeFromAccount(
      newAccountId,
      accountsFromAPI,
    );
    if (newEquityType) {
      setEquityType(newEquityType);
      localStorage.setItem("equity-mode", newEquityType);
    }

    // Update deposit currency and trigger recalculation
    const accountCurrency = getAccountCurrency(newAccountId);
    setDepositCurrency(accountCurrency);

    // Clear and recalculate if we have a pair selected
    if (pair) {
      clearCalcFields();
      runOandaFunc(pair);
    }
  };

  const handleOpenPriceChange = (event) => {
    const value = event.target.value;
    setOpenPrice(value);

    // Set flag to prevent auto-recalculation
    openPriceChangedRef.current = true;

    // Clear stop price and stop pips when user modifies open price
    setStopPrice("");
    setStopLossPips(0);
  };

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "unset";
  }, [open]);

  useEffect(() => {
    setEquityType(localStorage.getItem("equity-mode"));
    // Don't restore account selection - start fresh with no account selected
    setSelectedAccountId("");
    setDepositCurrency("USD");
    refreshSavedSlots();
    fetchRecentTrades();
  }, []);

  // Disable body scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  // init calculator when modal opens
  useEffect(() => {
    if (!open) return;

    // Clear account selection when modal opens
    setSelectedAccountId("");
    localStorage.setItem("selected-account-id", "");
    setDepositCurrency("USD");

    // Set balance to 0 when no account is selected
    setAccountBalance("0");
    oandaConnect();
  }, [open]);

  // useEffect(() => {
  //   const found = markets.find((p) => p.ticker === pair);
  //   // if (found?.session) {
  //   //   setSession(found.session);
  //   //   setSessionTimezone(found.sessionTimezone || "");
  //   // } else {
  //   //   setSession("");
  //   //   setSessionTimezone("");
  //   // }
  // }, [pair]);

  // Update account balance when selected account changes
  useEffect(() => {
    if (open && selectedAccountId) {
      setAccountBalance(Number(getBalance()).toFixed(2));
    }
  }, [selectedAccountId, open, getBalance]);

  // Update entry time label when selected account changes
  useEffect(() => {
    if (selectedAccountId) {
      setEntryTimeLabel(getServerTimeLabel(selectedAccountId));
    } else {
      setEntryTimeLabel("Entry Time Server");
    }
  }, [selectedAccountId, getServerTimeLabel]);

  // Update entry time label every minute to show current server time
  useEffect(() => {
    if (!selectedAccountId) return;

    // Update immediately
    setEntryTimeLabel(getServerTimeLabel(selectedAccountId));

    // Set up interval to update every minute
    const interval = setInterval(() => {
      setEntryTimeLabel(getServerTimeLabel(selectedAccountId));
    }, 60000); // Update every 60 seconds

    return () => clearInterval(interval);
  }, [selectedAccountId, getServerTimeLabel]);

  return (
    <>
      <style>{`
        #new-entry-scroll::-webkit-scrollbar {
          display: none;
        }
        #saved-slots-scroll::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <Modal
        open={open}
        onClose={onClose}
        sx={{ zIndex: 10000 }}
        componentsProps={{
          backdrop: {
            sx: { zIndex: 9999 },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: "1200px",
            maxHeight: width <= 800 ? "100vh" : "90vh",
            backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#ffffff",
            borderRadius: width <= 800 ? "0px" : "16px",
            border:
              width <= 800
                ? "none"
                : theme[0] === "dark"
                  ? "1px solid #2c2d31"
                  : "1px solid #e5e7eb",
            boxShadow:
              theme[0] === "dark"
                ? "0 20px 60px rgba(0, 0, 0, 0.8)"
                : "0 20px 60px rgba(0, 0, 0, 0.15)",
            p: width <= 800 ? 2 : 4,
            pt: width <= 800 ? 8 : 4,
            pb: width <= 800 ? 8 : 4,
            outline: "none",
            zIndex: 10001,
          }}
        >
          <div
            id="new-entry-scroll"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              maxHeight: "calc(90vh - 32px)",
              overflowX: "hidden",
              overflowY: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {!checkListView ? (
              <>
                {/* HEADER WITH ACCOUNT SELECTOR */}
                <div
                  style={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: width <= 800 ? "column" : "row",
                      alignItems: width <= 800 ? "stretch" : "center",
                      justifyContent: "space-between",
                      gap: width <= 800 ? "16px" : "20px",
                      position: "relative",
                    }}
                  >
                    {/* Close Button - Mobile Only */}
                    {width <= 800 && (
                      <button
                        onClick={onClose}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "0px",
                          backgroundColor: "transparent",
                          border: "none",
                          color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                          cursor: "pointer",
                          padding: "8px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(156, 163, 175, 0.1)"
                              : "rgba(107, 114, 128, 0.1)";
                          e.currentTarget.style.color =
                            theme[0] === "dark" ? "#d1d5db" : "#4b5563";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.color =
                            theme[0] === "dark" ? "#9ca3af" : "#6b7280";
                        }}
                      >
                        <CloseIcon sx={{ fontSize: "25px" }} />
                      </button>
                    )}

                    <div style={{ width: "100%" }}>
                      {/* Saved Slots and Trading Account Row */}
                      <div style={{ marginTop: 0 }}>
                        <div
                          style={{
                            backgroundColor:
                              theme[0] === "dark" ? "#25262b" : "#f9fafb",
                            borderRadius: "12px",
                            padding: width <= 800 ? "16px" : "20px",
                            border:
                              theme[0] === "dark"
                                ? "1px solid #2d2e33"
                                : "1px solid #e5e7eb",
                          }}
                        >
                          {/* Trading Style Buttons + Account Selector Row */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "16px",

                              flexWrap: width <= 800 ? "wrap" : "nowrap",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                  width <= 800 ? "center" : "flex-start",
                                gap: "8px",
                                flexWrap: "wrap",
                                width: width <= 800 ? "100%" : "auto",
                              }}
                            >
                              {/* Trading Style as clickable title buttons */}
                              <div
                                style={{
                                  display: "inline-flex",
                                  gap: "0",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  border: `1px solid ${theme[0] === "dark" ? "#2d2e33" : "#e5e7eb"}`,
                                  backgroundColor:
                                    theme[0] === "dark" ? "#25262b" : "#f9fafb",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => setTradingStyle("Intraday")}
                                  style={{
                                    padding:
                                      width <= 600 ? "6px 12px" : "8px 16px",
                                    fontSize: width <= 600 ? "18px" : "22px",
                                    fontWeight: "600",
                                    letterSpacing: "-0.5px",
                                    border: "none",
                                    backgroundColor:
                                      tradingStyle === "Intraday"
                                        ? theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.15)"
                                          : "rgba(38, 166, 93, 0.1)"
                                        : "transparent",
                                    color:
                                      tradingStyle === "Intraday"
                                        ? "#26a65d"
                                        : theme[0] === "dark"
                                          ? "#9ca3af"
                                          : "#6b7280",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    userSelect: "none",
                                    WebkitTapHighlightColor: "transparent",
                                    touchAction: "manipulation",
                                    minHeight: "44px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onMouseEnter={(e) => {
                                    if (tradingStyle !== "Intraday") {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "#2d2e33"
                                          : "#e5e7eb";
                                    } else {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.25)"
                                          : "rgba(38, 166, 93, 0.15)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (tradingStyle !== "Intraday") {
                                      e.currentTarget.style.backgroundColor =
                                        "transparent";
                                    } else {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.15)"
                                          : "rgba(38, 166, 93, 0.1)";
                                    }
                                  }}
                                >
                                  Intraday
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setTradingStyle("Swing")}
                                  style={{
                                    padding:
                                      width <= 600 ? "6px 12px" : "8px 16px",
                                    fontSize: width <= 600 ? "18px" : "22px",
                                    fontWeight: "600",
                                    letterSpacing: "-0.5px",
                                    border: "none",
                                    backgroundColor:
                                      tradingStyle === "Swing"
                                        ? theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.15)"
                                          : "rgba(38, 166, 93, 0.1)"
                                        : "transparent",
                                    color:
                                      tradingStyle === "Swing"
                                        ? "#26a65d"
                                        : theme[0] === "dark"
                                          ? "#9ca3af"
                                          : "#6b7280",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    userSelect: "none",
                                    WebkitTapHighlightColor: "transparent",
                                    touchAction: "manipulation",
                                    minHeight: "44px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onMouseEnter={(e) => {
                                    if (tradingStyle !== "Swing") {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "#2d2e33"
                                          : "#e5e7eb";
                                    } else {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.25)"
                                          : "rgba(38, 166, 93, 0.15)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (tradingStyle !== "Swing") {
                                      e.currentTarget.style.backgroundColor =
                                        "transparent";
                                    } else {
                                      e.currentTarget.style.backgroundColor =
                                        theme[0] === "dark"
                                          ? "rgba(38, 166, 93, 0.15)"
                                          : "rgba(38, 166, 93, 0.1)";
                                    }
                                  }}
                                >
                                  Swing
                                </button>
                              </div>
                            </div>

                            {!auth.backtestingMode && (
                              <div
                                style={{
                                  minWidth: width <= 800 ? "100%" : "250px",
                                  maxWidth: width <= 800 ? "100%" : "300px",
                                }}
                              >
                                <AccountSelector
                                  value={selectedAccountId}
                                  onChange={handleAccountChange}
                                  size="small"
                                  fullWidth={true}
                                  showAggregateOptions={false}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Session note disabled - not ready for use yet
              {session && (() => {
                const sessionInfo = getLocalSessionInfo(session, sessionTimezone);
                if (!sessionInfo) return null;
                
                return (
                  <div style={{ marginBottom: "16px" }}>
                    <div
                      style={{
                        backgroundColor: sessionInfo.inSession 
                          ? (theme[0] === "dark" ? "rgba(34, 197, 94, 0.1)" : "rgba(34, 197, 94, 0.05)")
                          : (theme[0] === "dark" ? "rgba(239, 68, 68, 0.1)" : "rgba(239, 68, 68, 0.05)"),
                        border: sessionInfo.inSession
                          ? (theme[0] === "dark" ? "1px solid rgba(34, 197, 94, 0.3)" : "1px solid rgba(34, 197, 94, 0.2)")
                          : (theme[0] === "dark" ? "1px solid rgba(239, 68, 68, 0.3)" : "1px solid rgba(239, 68, 68, 0.2)"),
                        borderRadius: "8px",
                        padding: "12px 16px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          color: sessionInfo.inSession ? "#22c55e" : "#ef4444",
                          fontSize: "14px",
                          margin: 0,
                          fontWeight: "500",
                        }}
                      >
                        {sessionInfo.inSession ? "🟢 In Session" : "🔴 Out Of Session"} · {sessionInfo.startLocal}-{sessionInfo.endLocal} {sessionInfo.timezone}
                      </p>
                    </div>
                  </div>
                );
              })()}
              */}

                {/* COMBINED TRADE ENTRY SECTION */}
                <div style={{ marginBottom: "8px" }}>
                  <div
                    style={{
                      backgroundColor:
                        theme[0] === "dark" ? "#25262b" : "#f9fafb",
                      borderRadius: "12px",
                      padding: width <= 800 ? "16px" : "20px",
                      border:
                        theme[0] === "dark"
                          ? "1px solid #2d2e33"
                          : "1px solid #e5e7eb",
                    }}
                  >
                    {/* Title and Slots Row */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "16px",
                        marginBottom: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Instrument & Position
                      </p>

                      {/* Saved Slots */}
                      <div
                        id="saved-slots-scroll"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "8px",
                          flexWrap: "nowrap",
                          overflowX: "auto",
                          WebkitOverflowScrolling: "touch",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {savedSlots.map((slot, index) => (
                          <Tooltip key={slot._id} title={`Load ${slot.pair}`}>
                            <Chip
                              size="small"
                              label={`S${index + 1}: ${slot.pair}`}
                              onClick={() => loadSlot(slot._id)}
                              onDelete={() => clearSlot(slot._id)}
                              sx={{
                                height: "26px",
                                fontSize: "11px",
                                backgroundColor:
                                  theme[0] === "dark"
                                    ? "rgba(237, 158, 14, 0.15)"
                                    : "rgba(237, 158, 14, 0.1)",
                                color: "#ED9E0E",
                                border: "none",
                                flexShrink: 0,
                                "& .MuiChip-deleteIcon": {
                                  fontSize: "14px",
                                  color: "#ED9E0E",
                                },
                              }}
                            />
                          </Tooltip>
                        ))}
                        {savedSlots.length === 0 && (
                          <span
                            style={{
                              fontSize: "11px",
                              color:
                                theme[0] === "dark" ? "#6b7280" : "#9ca3af",
                              fontStyle: "italic",
                            }}
                          >
                            No saved slots
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: width <= 600 ? "1fr" : "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div>
                        <InstrumentSelect
                          value={pair}
                          onChange={(event) => {
                            const value = event.target.value;
                            setPair(value);
                            clearCalcFields();
                            runOandaFunc(value);
                            checkPairNews(value);
                          }}
                          size="small"
                          fullWidth
                        />
                      </div>
                      <div>
                        <CustomSelect
                          size="small"
                          placeholder="Direction"
                          value={direction}
                          onChange={(event) => setDirection(event.target.value)}
                          menuItemArray={JSON.stringify([
                            { value: "Long", label: "Long" },
                            { value: "Short", label: "Short" },
                          ])}
                          disabled={!pair}
                        />
                      </div>
                    </div>

                    {pair && pairNews.length === 0 && (
                      <div style={{ marginTop: "16px" }}>
                        <div
                          style={{
                            backgroundColor:
                              theme[0] === "dark"
                                ? "rgba(34, 197, 94, 0.1)"
                                : "rgba(34, 197, 94, 0.06)",
                            border: `1px solid ${
                              theme[0] === "dark"
                                ? "rgba(34, 197, 94, 0.35)"
                                : "rgba(34, 197, 94, 0.25)"
                            }`,
                            borderRadius: "8px",
                            padding: "10px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#22c55e",
                            }}
                          >
                            No upcoming high-impact news events for {pair} in
                            the next 24 hours
                          </span>
                        </div>
                      </div>
                    )}

                    {pairNews.length > 0 && (
                      <div style={{ marginTop: "16px" }}>
                        <div
                          style={{
                            backgroundColor:
                              theme[0] === "dark"
                                ? "rgba(198, 40, 40, 0.15)"
                                : "rgba(198, 40, 40, 0.08)",
                            border: `1px solid ${
                              theme[0] === "dark"
                                ? "rgba(198, 40, 40, 0.4)"
                                : "rgba(198, 40, 40, 0.25)"
                            }`,
                            borderRadius: "8px",
                            padding: "10px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#C62828",
                            }}
                          >
                            High-impact news events for {pair} in the next 24
                            hours
                          </span>
                        </div>
                      </div>
                    )}

                    <p
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                        margin: "24px 0 16px 0",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Risk Management
                    </p>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          width <= 600 ? "1fr" : "repeat(3, 1fr)",
                        gap: "16px",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color:
                              !pair || !direction || !openPrice
                                ? theme[0] === "dark"
                                  ? "#4b5563"
                                  : "#d1d5db"
                                : theme[0] === "dark"
                                  ? "#9ca3af"
                                  : "#6b7280",
                            display: "block",
                            marginBottom: "4px",
                          }}
                        >
                          {getStopLossLabel()}
                        </span>
                        <CustomSingleTextField
                          type="number"
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "^[0-9]*[.]?[0-9]*$",
                          }}
                          size="small"
                          fullWidth
                          disabled={!pair || !direction || !openPrice}
                          value={stopLossPips || ""}
                          onChange={(event) => {
                            handleStopLossChange(event.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                            display: "block",
                            marginBottom: "4px",
                          }}
                        >
                          Risk %
                        </span>
                        <CustomSingleTextField
                          type="number"
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "^[0-9]*[.]?[0-9]*$",
                          }}
                          size="small"
                          fullWidth
                          value={risk}
                          onChange={(event) => setRisk(event.target.value)}
                        />
                      </div>
                      <div>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                            display: "block",
                            marginBottom: "4px",
                          }}
                        >
                          Account Balance
                        </span>
                        <CustomSingleTextField
                          type="number"
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "^[0-9]*[.]?[0-9]*$",
                          }}
                          size="small"
                          fullWidth
                          value={accountBalance || "0"}
                          onChange={(event) => {
                            clearCalcFields();
                            setAccountBalance(event.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <p
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                        margin: "24px 0 16px 0",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Entry Details
                    </p>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: width <= 600 ? "1fr" : "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color:
                              !pair || !direction
                                ? theme[0] === "dark"
                                  ? "#4b5563"
                                  : "#d1d5db"
                                : theme[0] === "dark"
                                  ? "#9ca3af"
                                  : "#6b7280",
                            display: "block",
                            marginBottom: "4px",
                          }}
                        >
                          Open Price
                        </span>
                        <CustomSingleTextField
                          type="number"
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "^[0-9]*[.]?[0-9]*$",
                          }}
                          size="small"
                          fullWidth
                          disabled={!pair || !direction}
                          value={openPrice}
                          onChange={handleOpenPriceChange}
                        />
                      </div>
                      {auth.backtestingMode && (
                        <div>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "500",
                              color:
                                theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                              display: "block",
                              marginBottom: "4px",
                            }}
                          >
                            Close Price
                          </span>
                          <CustomSingleTextField
                            type="number"
                            inputProps={{
                              inputMode: "decimal",
                              pattern: "^[0-9]*[.]?[0-9]*$",
                            }}
                            size="small"
                            fullWidth
                            value={closePrice}
                            onChange={(event) =>
                              setClosePrice(event.target.value)
                            }
                          />
                        </div>
                      )}
                      <div>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: "500",
                            color:
                              !pair || !direction || !openPrice
                                ? theme[0] === "dark"
                                  ? "#4b5563"
                                  : "#d1d5db"
                                : theme[0] === "dark"
                                  ? "#9ca3af"
                                  : "#6b7280",
                            display: "block",
                            marginBottom: "4px",
                          }}
                        >
                          Stop Price
                        </span>
                        <CustomSingleTextField
                          type="number"
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "^[0-9]*[.]?[0-9]*$",
                          }}
                          size="small"
                          fullWidth
                          disabled={!pair || !direction || !openPrice}
                          value={stopPrice}
                          onChange={(event) =>
                            handleStopPriceChange(event.target.value)
                          }
                        />
                      </div>
                      <div>
                        {auth.backtestingMode && (
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "500",
                              color:
                                theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                              display: "block",
                              marginBottom: "4px",
                              visibility: "hidden",
                            }}
                          >
                            Close Price
                          </span>
                        )}
                        <CustomDateTimePicker
                          defaultValue={entry}
                          size="small"
                          label={entryTimeLabel}
                          value={entry}
                          onChange={(newValue) => {
                            setEntry(newValue.$d);
                          }}
                        />
                      </div>
                      <div>
                        <CustomSelect
                          size="small"
                          placeholder="Load Previous Trade"
                          value={selectedTradeToLoad}
                          onChange={(event) => {
                            const tradeId = event.target.value;
                            setSelectedTradeToLoad(tradeId);
                            if (tradeId) {
                              loadTradeFromHistory(tradeId);
                            }
                          }}
                          menuItemArray={JSON.stringify(
                            recentTrades.length > 0
                              ? recentTrades.map((trade) => {
                                  const user = JSON.parse(
                                    localStorage.getItem("user") || "{}",
                                  );
                                  const accounts = user.capitalAccounts || [];
                                  const account = accounts.find(
                                    (acc) => acc.id === trade.accountId,
                                  );
                                  const accountName = account
                                    ? account.name
                                    : "Unknown";

                                  return {
                                    value: trade._id,
                                    label: `${trade.pair} ${trade.direction} - ${trade.entryDate} (${accountName})`,
                                  };
                                })
                              : [{ value: "", label: "No recent trades" }],
                          )}
                        />
                      </div>
                      {auth.backtestingMode && (
                        <div>
                          <CustomDateTimePicker
                            defaultValue={exit}
                            size="small"
                            label="Exit Time"
                            value={exit}
                            onChange={(newValue) => {
                              setExit(newValue.$d);
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* BACKTESTING SECTION INSIDE ENTRY DETAILS */}
                    {auth.backtestingMode && (
                      <>
                        <div
                          style={{
                            height: "1px",
                            backgroundColor:
                              theme[0] === "dark" ? "#2c2d31" : "#e5e7eb",
                            margin: "24px 0",
                          }}
                        />
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              width <= 600 ? "1fr" : "1fr 1fr",
                            gap: "16px",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <UnarchivedTestsDropDown
                              selectedTest={assignedTestId}
                              onTestSelect={(testId) => {
                                const selectedBacktest = auth.backtests?.find(
                                  (test) => test.testId === testId,
                                );
                                if (selectedBacktest) {
                                  assignTrade(selectedBacktest);
                                  handleMissedNo({ target: { value: "No" } });
                                }
                              }}
                              showBacktestTrades={(test) => assignTrade(test)}
                              label="Select Backtest"
                              includeMissedTrades={false}
                              fullWidth={true}
                            />
                          </div>
                          <div>
                            <FormControl
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <FormLabel
                                sx={{
                                  color:
                                    theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  mb: 0.5,
                                }}
                                id="missed-trade-label"
                              >
                                Missed Trade
                              </FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="missed-trade-label"
                                value={missedTradeYes || "No"}
                                sx={{
                                  color:
                                    theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={
                                    <Radio
                                      onChange={handleMissedYes}
                                      sx={{
                                        color:
                                          theme[0] === "dark"
                                            ? "#9ca3af"
                                            : "#6b7280",
                                        "&.Mui-checked": {
                                          color: "#f23645",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "20px",
                                        },
                                        "&:hover": {
                                          backgroundColor:
                                            theme[0] === "dark"
                                              ? "rgba(242, 54, 69, 0.08)"
                                              : "rgba(242, 54, 69, 0.04)",
                                        },
                                      }}
                                    />
                                  }
                                  label="Yes"
                                  sx={{
                                    "& .MuiFormControlLabel-label": {
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color:
                                        theme[0] === "dark"
                                          ? "#FCFCFF"
                                          : "#1a1b1e",
                                      ml: 1,
                                    },
                                  }}
                                />
                                <FormControlLabel
                                  value="No"
                                  control={
                                    <Radio
                                      onChange={handleMissedNo}
                                      sx={{
                                        color:
                                          theme[0] === "dark"
                                            ? "#9ca3af"
                                            : "#6b7280",
                                        "&.Mui-checked": {
                                          color: "#3b82f6",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "20px",
                                        },
                                        "&:hover": {
                                          backgroundColor:
                                            theme[0] === "dark"
                                              ? "rgba(59, 130, 246, 0.08)"
                                              : "rgba(59, 130, 246, 0.04)",
                                        },
                                      }}
                                    />
                                  }
                                  label="No"
                                  sx={{
                                    "& .MuiFormControlLabel-label": {
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color:
                                        theme[0] === "dark"
                                          ? "#FCFCFF"
                                          : "#1a1b1e",
                                      ml: 1,
                                    },
                                  }}
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                          {missedTrade && (
                            <div
                              style={{
                                gridColumn: width <= 600 ? "span 1" : "span 1",
                              }}
                            >
                              {getLiveAccountBalances().length > 0 ? (
                                <CustomSelect
                                  value={selectedLiveAccount}
                                  onChange={(e) =>
                                    handleLiveAccountSelect(e.target.value)
                                  }
                                  size="small"
                                  placeholder="Select Account Balance"
                                  menuItemArray={JSON.stringify(
                                    getLiveAccountBalances().map((account) => ({
                                      value: account.id,
                                      label: `${account.name} - $${account.balance}`,
                                    })),
                                  )}
                                />
                              ) : (
                                <CustomSingleTextField
                                  size="small"
                                  fullWidth
                                  placeholder="Account Balance"
                                  value="0"
                                  disabled
                                  style={{ opacity: 0.6 }}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* RISK MANAGEMENT SECTION */}
                <div style={{ marginBottom: 0 }}>
                  <PositionVisualizer
                    direction={direction}
                    openPrice={openPrice}
                    stopPrice={stopPrice}
                    stopLossPips={stopLossPips}
                    lots={lots}
                    units={units}
                    moneyRisk={moneyRisk}
                    risk={risk}
                    depositCurrency={depositCurrency}
                    exchangeRate={exchangeRate}
                    exchangeLabel={exchangeLabel}
                    contractSize={contractSize}
                    setContractSize={setContractSize}
                    saveContractSize={saveContractSize}
                    customContractSize={customContractSize}
                    setCustomContractSize={setCustomContractSize}
                    showContractDropdown={showContractDropdown}
                    setShowContractDropdown={setShowContractDropdown}
                    accountBalance={accountBalance}
                    pair={pair}
                    width={width}
                  />
                </div>

                {/* ACTION BUTTONS */}
                <div
                  style={{
                    paddingTop: "24px",
                    paddingBottom: width > 800 ? "48px" : "0",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        width <= 500 ? "repeat(5, 1fr)" : "repeat(5, 1fr)",
                      gap: width <= 500 ? "6px" : "12px",
                    }}
                  >
                    <div>
                      <button
                        onClick={() => runCals()}
                        style={{
                          width: "100%",
                          padding: width <= 500 ? "12px 8px" : "12px 16px",
                          backgroundColor:
                            theme[0] === "dark"
                              ? "rgba(237, 158, 14, 0.15)"
                              : "rgba(237, 158, 14, 0.1)",
                          border:
                            theme[0] === "dark"
                              ? "1px solid rgba(237, 158, 14, 0.4)"
                              : "1px solid rgba(237, 158, 14, 0.3)",
                          borderRadius: "8px",
                          color: "#ED9E0E",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(237, 158, 14, 0.25)"
                              : "rgba(237, 158, 14, 0.15)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(237, 158, 14, 0.15)"
                              : "rgba(237, 158, 14, 0.1)";
                        }}
                      >
                        <CalculateIcon fontSize="small" />
                        {width > 500 && "Calculate"}
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => save(preTradeCheckList)}
                        style={{
                          width: "100%",
                          padding: width <= 500 ? "12px 8px" : "12px 16px",
                          backgroundColor:
                            theme[0] === "dark"
                              ? "rgba(28, 131, 222, 0.15)"
                              : "rgba(28, 131, 222, 0.1)",
                          border:
                            theme[0] === "dark"
                              ? "1px solid rgba(28, 131, 222, 0.4)"
                              : "1px solid rgba(28, 131, 222, 0.3)",
                          borderRadius: "8px",
                          color: "#1C83DE",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(28, 131, 222, 0.25)"
                              : "rgba(28, 131, 222, 0.15)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(28, 131, 222, 0.15)"
                              : "rgba(28, 131, 222, 0.1)";
                        }}
                      >
                        <ContentCopyIcon fontSize="small" />
                        {width > 500 && "Save"}
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => handleCreateForecast()}
                        style={{
                          width: "100%",
                          padding: width <= 500 ? "12px 8px" : "12px 16px",
                          backgroundColor:
                            theme[0] === "dark"
                              ? "rgba(147, 51, 234, 0.15)"
                              : "rgba(147, 51, 234, 0.1)",
                          border:
                            theme[0] === "dark"
                              ? "1px solid rgba(147, 51, 234, 0.4)"
                              : "1px solid rgba(147, 51, 234, 0.3)",
                          borderRadius: "8px",
                          color: "#9333EA",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(147, 51, 234, 0.25)"
                              : "rgba(147, 51, 234, 0.15)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(147, 51, 234, 0.15)"
                              : "rgba(147, 51, 234, 0.1)";
                        }}
                      >
                        <TrendingUpIcon fontSize="small" />
                        {width > 500 && "Forecast"}
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => clearForm()}
                        style={{
                          width: "100%",
                          padding: width <= 500 ? "12px 8px" : "12px 16px",
                          backgroundColor:
                            theme[0] === "dark"
                              ? "rgba(211, 78, 78, 0.15)"
                              : "rgba(211, 78, 78, 0.1)",
                          border:
                            theme[0] === "dark"
                              ? "1px solid rgba(211, 78, 78, 0.4)"
                              : "1px solid rgba(211, 78, 78, 0.3)",
                          borderRadius: "8px",
                          color: "#D34E4E",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(211, 78, 78, 0.25)"
                              : "rgba(211, 78, 78, 0.15)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme[0] === "dark"
                              ? "rgba(211, 78, 78, 0.15)"
                              : "rgba(211, 78, 78, 0.1)";
                        }}
                      >
                        <ClearAllIcon fontSize="small" />
                        {width > 500 && "Clear"}
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={() => submit(onClose)}
                        disabled={formSubmitted}
                        style={{
                          width: "100%",
                          padding: width <= 500 ? "12px 8px" : "12px 16px",
                          backgroundColor: formSubmitted
                            ? theme[0] === "dark"
                              ? "#2d2e33"
                              : "#e5e7eb"
                            : theme[0] === "dark"
                              ? "rgba(38, 166, 93, 0.15)"
                              : "rgba(38, 166, 93, 0.1)",
                          border: formSubmitted
                            ? theme[0] === "dark"
                              ? "1px solid #3a3b3e"
                              : "1px solid #d1d5db"
                            : theme[0] === "dark"
                              ? "1px solid rgba(38, 166, 93, 0.4)"
                              : "1px solid rgba(38, 166, 93, 0.3)",
                          borderRadius: "8px",
                          color: formSubmitted
                            ? theme[0] === "dark"
                              ? "#6b7280"
                              : "#9ca3af"
                            : "#26a65d",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: formSubmitted ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          if (!formSubmitted) {
                            e.currentTarget.style.backgroundColor =
                              theme[0] === "dark"
                                ? "rgba(38, 166, 93, 0.25)"
                                : "rgba(38, 166, 93, 0.15)";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!formSubmitted) {
                            e.currentTarget.style.backgroundColor =
                              theme[0] === "dark"
                                ? "rgba(38, 166, 93, 0.15)"
                                : "rgba(38, 166, 93, 0.1)";
                          }
                        }}
                      >
                        <SaveIcon fontSize="small" />
                        {width > 500 && "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h4
                  style={{
                    textAlign: "center",
                    fontWeight: "300",
                    color: theme[0] === "dark" ? "#FCFCFF" : "black",
                    borderBottom:
                      theme[0] === "dark"
                        ? " 1px solid #FCFCFF"
                        : "1px solid rgba(37,37,37)",
                    width: "60%",
                    margin: "15px auto 30px auto",
                    padding: "10px 0 10px 0",
                  }}
                >
                  Pre-Trade Checklist
                </h4>
                <QuestionsList />
                <div
                  style={{
                    margin: "1em auto 0 auto",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "35px",
                  }}
                >
                  <Tooltip title="Continue">
                    <CheckOutlinedIcon
                      sx={{
                        color: "#26a65d",
                        cursor: "pointer",
                      }}
                      fontSize="large"
                      onClick={handleChecklist}
                    />
                  </Tooltip>
                </div>
              </>
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default NewEntry;
